import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, FileText, Image, Images, BookOpen, UtensilsCrossed,
  Inbox, Settings, Quote, Newspaper, LogOut, Leaf, ExternalLink, ScrollText, Phone,
} from "lucide-react";

const LINKS = [
  ["/admin", "Dashboard", LayoutDashboard, true],
  ["/admin/pages", "Pages", FileText],
  ["/admin/slides", "Homepage Hero", Images],
  ["/admin/recipes", "Recipes", UtensilsCrossed],
  ["/admin/blog", "Blog", BookOpen],
  ["/admin/media", "Media Library", Image],
  ["/admin/testimonials", "Testimonials", Quote],
  ["/admin/press", "Media Coverage", Newspaper],
  ["/admin/enquiries", "Enquiries", Inbox],
  ["/admin/contact-page", "Contact Page", Phone],
  ["/admin/settings", "Settings", Settings],
  ["/admin/audit", "Audit Log", ScrollText],
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-stone-100 flex">
      <aside className="w-64 bg-emerald-950 text-stone-200 min-h-screen flex flex-col fixed inset-y-0 left-0 z-40">
        <div className="p-5 border-b border-emerald-800/60 flex items-center gap-2">
          <span className="w-9 h-9 rounded-full bg-emerald-800 text-amber-50 flex items-center justify-center"><Leaf size={18} /></span>
          <div><p className="font-serif text-amber-50 leading-tight">Healthy Roots</p><p className="text-[10px] uppercase tracking-widest text-emerald-400">CMS Admin</p></div>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
          {LINKS.map(([to, label, Icon, end]) => (
            <NavLink key={to} to={to} end={end}
              data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-emerald-800 text-amber-50" : "text-stone-300 hover:bg-emerald-900/60"}`}>
              <Icon size={17} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-emerald-800/60 space-y-1">
          <a href="/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-stone-300 hover:bg-emerald-900/60"><ExternalLink size={17} /> View Site</a>
          <button onClick={() => { logout(); nav("/admin/login"); }} data-testid="admin-logout-btn" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-stone-300 hover:bg-emerald-900/60"><LogOut size={17} /> Log out</button>
          <p className="px-3 pt-2 text-[11px] text-emerald-500 truncate">{user?.email}</p>
        </div>
      </aside>
      <div className="flex-1 ml-64 p-8">{children}</div>
    </div>
  );
}
